import { Injectable, Injector, OnDestroy, OnInit } from "@angular/core";
import { Subscription } from "rxjs";

import { DataLinkClient, DataNotificationRunCommand } from "src/app/api";

import { FieldMetadata, FieldWidthEnum, KeyValue, ViewMetadata } from "src/cer/cer-data/cer-data-types";
import { UiCommand, UiCommandEvent } from "@ui/cer-ui-types";
import { CerPromptService } from "@ui/cer-ui-prompt.service";

@Injectable({ providedIn: 'root' })
export class CerAppDataNotificationService implements OnInit, OnDestroy {

  private subscriptionManager$: Subscription = new Subscription();

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.subscriptionManager$.unsubscribe();
  }

  private static viewMetadata: ViewMetadata = {
    name: 'notifikationer', dataApiName: 'DataNotification', text: 'Notifikationer', textSingular: 'Notifikation',
    primaryKey: 'id', parentPrimaryKey: 'id', parentForeignKey: 'row', titleFields: ['name'],
    allowEdit: true, allowCreate: true, allowDelete: true, baseFields: ['id', 'name', 'history']
  };

  public static fieldMetadata: FieldMetadata[] = [
    { name: 'active', text: 'Aktiv', format: 'CheckBox', defaultValue: 1 },
    { name: 'template', text: 'Skabelon', required: true, foreignKeyTableName: 'MailTemplate', widthType: FieldWidthEnum.XS},
    { name: 'address', text: 'E-mail adresser', required: true},
    { name: 'schedule', text: 'Gentagelse', required: true, foreignKeyTableName: 'ScheduleType', widthType: FieldWidthEnum.XS},
    { name: 'nextRun', text: 'Næste afvikling', format: 'DateTime', allowEdit: false, allowEditOnAdd: false },
    { name: 'row', text: 'Tabel post', widthType: FieldWidthEnum.XS, allowEdit: false, allowEditOnAdd: false, visible: false },
    { name: 'table', text: 'Tabel', widthType: FieldWidthEnum.XS, allowEdit: false, allowEditOnAdd: false, visible: false },
    { name: 'tableName', text: 'Tabel', widthType: FieldWidthEnum.XS, allowEdit: false, allowEditOnAdd: false, visible: false },
  ];

  public static uiCmdDataNotificationRun: UiCommand = { id: 'DataNotificationRun', text: "Kør", iconCss: "e-menu-icon e-icons e-excelexport", tooltipText: 'Kør notifikation nu', target: ".e-headercontent", align: "right", needSelection: true };
  public static toolbarCommands: UiCommand[] = [
     CerAppDataNotificationService.uiCmdDataNotificationRun
  ];

  /*
  private grid: CerGridComponent;
  public Grid(grid: CerGridComponent) {
    this.grid = grid;
    this.subscriptionManager$.add(this.grid.commmand.subscribe(event => CerDataNotificationService.onCommand(event)));
  }*/

  public static onCommand(event: UiCommandEvent, injector: Injector): void {
    switch (event.commandId)
    {
      case CerAppDataNotificationService.uiCmdDataNotificationRun.id:
        this.NotificationRun(event,injector);
        break;
    }
  }

  public static NotificationRun(event: UiCommandEvent, injector: Injector) {
        var id = event.rowData?.id;
        if (id == null)
        {
          return;
        }
        var ui : CerPromptService = injector.get(CerPromptService);
        ui.operationBegin('Sender notifikation', 'Vent venligst...');
        var client: DataLinkClient = injector.get(DataLinkClient);
        var cmd : DataNotificationRunCommand = new DataNotificationRunCommand({dataNotificationId: id });
        client.dataNotificationRun(cmd).subscribe({
          next: (result) => {
            ui.operationEnd();
            ui.infoToast('Notifikation sendt');
          },
          error: (error) => {
            ui.operationEndError(error);
          }
        });
    
  }

  public static viewMetadataGet(dataLinkTables: string[]): ViewMetadata {
    var view: ViewMetadata = Object.assign({}, CerAppDataNotificationService.viewMetadata);

    if (dataLinkTables != null && dataLinkTables.length > 0) {
      var dataApiParams: KeyValue[] = [];

      var n = 1;
      dataLinkTables.forEach((tableName) => {
        var keyNum: string = (n == 1 ? '' : n.toString());
        dataApiParams.push({ key: '$dataLink' + keyNum + 'Table', value: tableName });
        n++;
      });

      view.dataApiParams = dataApiParams;
    }
    return view;
  }

  public static fieldMetadataGet(defaultTableName: string): FieldMetadata[] {
    var fieldMetadata: FieldMetadata[] = [];
    CerAppDataNotificationService.fieldMetadata.forEach((field) => {
      if (field.name == 'tableName') {
        field.defaultValue = defaultTableName;
      }
      if (field.name == 'created' ||
          field.name == 'createdBy') {
        field.visible = true;
      }
      fieldMetadata.push(Object.assign({}, field));
    });
    return fieldMetadata;
  }

}